
(function(){
  function setOpen(item, open){
    var a=item.querySelector('.faq-a');
    var ch=item.querySelector('.faq-chevron');
    if(a){
      if(open){
        a.style.setProperty('display','block','important');
        a.style.setProperty('max-height','none','important');
        a.style.setProperty('height','auto','important');
        a.style.setProperty('opacity','1','important');
        a.style.setProperty('overflow','visible','important');
        a.style.setProperty('padding','0 2px 14px','important');
      } else {
        a.style.setProperty('display','none','important');
      }
    }
    if(ch){ ch.style.transition='transform .2s ease'; ch.style.transform = open ? 'rotate(180deg)' : 'none'; }
    item.classList.toggle('open', open);
    item.setAttribute('data-open', open ? '1' : '0');
  }
  function init(){
    var fab=document.getElementById('faqFab'), ov=document.getElementById('faqModalOverlay'), cl=document.getElementById('faqModalClose');
    if(!fab||!ov) return;

    /* Base look for the questions, independent of theme.css */
    var st=document.createElement('style');
    st.textContent =
      '#faqModalOverlay .faq-item{border-bottom:1px solid #F2D9E2;}' +
      '#faqModalOverlay .faq-item:last-child{border-bottom:none;}' +
      '#faqModalOverlay .faq-q{width:100%;display:flex;align-items:center;justify-content:space-between;gap:10px;background:none;border:none;font-family:inherit;font-weight:700;font-size:15px;color:#2B1620;text-align:left;padding:14px 2px;cursor:pointer;-webkit-tap-highlight-color:rgba(214,66,112,.15);}' +
      '#faqModalOverlay .faq-chevron{color:#D64270;flex:0 0 auto;font-size:16px;}' +
      '#faqModalOverlay .faq-a p{margin:0;font-size:13.5px;line-height:1.6;color:#5B4450;}';
    document.head.appendChild(st);

    /* Start closed via inline styles so no stylesheet rule is needed */
    ov.querySelectorAll('.faq-item').forEach(function(it){ setOpen(it,false); });

    function close(){ ov.style.display='none'; }
    fab.addEventListener('click',function(){ ov.style.display='flex'; });
    if(cl) cl.addEventListener('click',close);
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });

    /* One handler for all questions; opens one at a time */
    ov.addEventListener('click',function(e){
      var q = e.target.closest ? e.target.closest('.faq-q') : null;
      if(!q) return;
      e.preventDefault();
      var item = q.closest('.faq-item') || q.parentElement;
      var wasOpen = item.getAttribute('data-open')==='1';
      ov.querySelectorAll('.faq-item').forEach(function(it){ setOpen(it,false); });
      if(!wasOpen) setOpen(item,true);
    });
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
